import Actions from '@app/action';
import Store from '@app/store';

import Analytics from '@module/analytics';

export const shouldAskBeforeLeaving = (route) =>
  route.unSavedForm || route.isMobileTransfer;

export function createOnRouteHandler(router) {
  return function handleOnRoute(route) {
    const { user } = Store.getState();

    // Does this route require authentication?
    if (route.auth && !user.loggedIn) {
      router.resolve('/sign-in', false);
      Store.dispatch(Actions.Session.setRedirect(route.path));
      return;
    }

    if (
      Array.isArray(route.planTiers) &&
      !route.planTiers.includes(user.planTier)
    ) {
      router.resolve('/', false);
      return;
    }

    // Record page view
    Analytics.pageView(location.pathname + location.search);

    // Update the Route in our store.
    Store.dispatch(Actions.Route.setRoute(route));
  };
}
